
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.63 10h-3.01a.989.989 0 01-1.003-1c0-.531.44-1 1.003-1h3.01s3.009-3.344 3.009-5c0-1.656-1.348-3-3.01-3a3.005 3.005 0 00-3.009 3c0 .813.69 2 1.411 3h-1.41C8.958 6 7.61 7.375 7.61 9c0 1.656 1.348 3 3.01 3h3.009c.532 0 1.003.469 1.003 1 0 .563-.47 1-1.003 1H6.389a22.44 22.44 0 01-1.473 2h8.714c1.63 0 3.009-1.344 3.009-3 0-1.625-1.38-3-3.01-3zm0-8c.532 0 1.003.469 1.003 1 0 .563-.47 1-1.003 1a.989.989 0 01-1.004-1c0-.531.44-1 1.004-1zM3.599 8a3.005 3.005 0 00-3.01 3c0 1.656 3.01 5 3.01 5s3.01-3.344 3.01-5c0-1.656-1.349-3-3.01-3zm0 4a.989.989 0 01-1.003-1c0-.531.439-1 1.003-1 .533 0 1.003.469 1.003 1 0 .563-.47 1-1.003 1z","fill":"currentColor"}})])
          )
        }
      }
    